import React from "react";
import { _goToCategory } from "routers/helper";

import { View, StyleSheet, TouchableOpacity } from "react-native";

import Text from "components/Text";
import Icon from "components/Icon";
import Shadow from "components/Shadow";
import Separator from "components/Separator";

import { sizes, colors } from "assets/constants";

export default function CategoryBox(props: { cat: CategoryT }) {
  const { id, title, children: subsCat } = props.cat;

  const _goToEdit = () => id && _goToCategory({ id });

  return (
    <Shadow style={styles.container}>
      <TouchableOpacity
        activeOpacity={sizes.tapOpacity}
        onPress={_goToEdit}
        style={styles.header}
      >
        <Text weight="bold" size={"lg"}>
          {" "}
          {title}
        </Text>
        <Separator cover />
        <Icon type={"feather"} name={"more-vertical"} />
      </TouchableOpacity>

      {subsCat && subsCat?.length > 0 ? (
        <View style={styles.subCategories}>
          {subsCat?.map((sub: CategoryT, key: number) => (
            <TouchableOpacity
              key={String(key)}
              style={styles.subCatBox}
              activeOpacity={sizes.tapOpacity}
              onPress={() => _goToCategory({ id: sub.id })}
            >
              <Text>{sub.title}</Text>
            </TouchableOpacity>
          ))}
        </View>
      ) : (
        <View style={{ marginHorizontal: sizes.space }}>
          <Text size={"sm"} color={colors.textColorGray}>
            زیر گروهی برای این گروه تعریف نشده است
          </Text>
        </View>
      )}
    </Shadow>
  );
}

const styles = StyleSheet.create({
  container: {
    minHeight: 100,
    width: "100%",
    overflow: "hidden",
    backgroundColor: colors.white,
    borderRadius: sizes.radius.xl,
  },

  header: {
    width: "100%",
    alignItems: "center",
    padding: sizes.space,
    flexDirection: "row-reverse",
    backgroundColor: colors.white,
  },

  subCategories: {
    flexWrap: "wrap",
    alignItems: "center",
    flexDirection: "row-reverse",
  },

  subCatBox: {
    margin: 5,
    flexDirection: "row-reverse",
    borderRadius: sizes.radius.xl,
    paddingHorizontal: sizes.space,
    paddingVertical: sizes.space / 2,
    backgroundColor: colors.light._09,
  },
});
